import Dialog from '#lib/components/dialog.jsx';
import FloatingTooltip from './tooltip.jsx';
import { addClasses, cn } from '#lib/helpers/class.js';
import { SparklesIcon } from '@heroicons/react/24/outline/index.js';
import { Icon } from '@iconify-icon/react';
import { ungroup } from '#@itinerary/places/helpers.js';

export default function PopUp(props) {
    const { isOpen, onClose, addPlan, places, types } = props;

    const handleAddPlan = (type) => {
        onClose(type);
        if (type !== 'flight') setTimeout(() => addPlan(type), 250);
        //TODO: CAPIRE COME FAR PRIMA CHIUDERE LA MODALE E POI RENDERIZZARE IL DETTAGLIO DEL PLAN DI MODO DA FAR ANDARE IN FOCUS IL TITOLO
    };

    const ungroupedPlaces = ungroup(places);
    const suggestions = ungroupedPlaces.filter((el) => el.type === 'suggestions');
    const infos = ungroupedPlaces.filter((el) => el.type === 'info');

    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col gap-4 max-w-[1500px]">
                <div className="pr-4">
                    <Dialog.CloseButton />
                    <b>{_t.edit.planner.popupText()}</b>
                    <p className="pr-2 mt-1 text-sm">{_t.edit.planner.popupDescription()}</p>
                </div>

                <div
                    className={`w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-${types.length} gap-4 place-items-center`}
                >
                    {types.map((type) => {
                        const noSuggestions = type === 'suggestion' && suggestions.length === 0;
                        const noInfos = type === 'info' && infos.length === 0;
                        return (
                            <FloatingTooltip
                                key={type}
                                content={`You need to generate a ${type} place`}
                                placement="top"
                                className={addClasses(cn('col-span-1', !(noSuggestions || noInfos) && 'hidden'))}
                            >
                                <div
                                    className={cn(
                                        'flex flex-col gap-3 items-center w-32 lg:w-28 px-2 py-4',
                                        !(noSuggestions || noInfos)
                                            ? 'bg-slate-100 border border-slate-200 rounded-lg cursor-pointer hover:bg-primary-50 hover:border-primary-400'
                                            : 'bg-slate-50 border border-slate-200 rounded-lg'
                                    )}
                                    onClick={noSuggestions || noInfos ? () => null : () => handleAddPlan(type)}
                                >
                                    {type === 'activity' && (
                                        <Icon
                                            icon="material-symbols:calendar-month-outline-rounded"
                                            width="1.2rem"
                                            height="1.2rem"
                                            className={'pt-[2px]'}
                                        />
                                    )}
                                    {type === 'accommodation' && (
                                        <Icon
                                            icon="material-symbols:hotel-outline-rounded"
                                            width="1.2rem"
                                            height="1.2rem"
                                            className="pt-[4px]"
                                        />
                                    )}
                                    {type === 'flight' && (
                                        <Icon
                                            icon="tabler:plane-tilt"
                                            width="1.2rem"
                                            height="1.2rem"
                                            className={noSuggestions ? 'pt-[3px] text-stone-500' : 'pt-[3px]'}
                                        />
                                    )}
                                    {type === 'transfer' && (
                                        <Icon
                                            icon="bx:trip"
                                            width="1.2rem"
                                            height="1.2rem"
                                            className={noSuggestions ? 'pt-[2px] text-stone-500' : 'pt-[2px]'}
                                        />
                                    )}
                                    {type === 'custom' && (
                                        <Icon
                                            icon="material-symbols:inbox-customize-outline-rounded"
                                            width="1.2rem"
                                            height="1.2rem"
                                            className="pt-[3px]"
                                        />
                                    )}
                                    {type === 'suggestion' && (
                                        <SparklesIcon
                                            width={20}
                                            height={20}
                                            className={cn(noSuggestions && 'text-neutral-400')}
                                        />
                                    )}
                                    {type === 'info' && (
                                        <Icon
                                            icon="material-symbols:info-outline-rounded"
                                            width={20}
                                            height={20}
                                            className={cn(noInfos && 'text-neutral-400')}
                                        />
                                    )}
                                    {type === 'template' && (
                                        <Icon icon="majesticons:book-plus-line" width="1.3rem" height="1.3rem" />
                                    )}

                                    <p
                                        className={cn(
                                            'text-xs text-ellipsis text-center w-full',
                                            (noSuggestions || noInfos) && 'text-slate-500'
                                        )}
                                    >
                                        {_t.edit.planner[type]()}
                                    </p>
                                </div>
                            </FloatingTooltip>
                        );
                    })}
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
